import { toI18n } from 'util/i18n';

export const CODE_LENGTH = 6;

export const AUTH_EXPIRATION_MS = 300000;

export const STORED_REDIRECT_KEY = 'LINK_LOGIN_REDIRECT_STORAGE_KEY';
export const STORED_EMAIL_KEY = 'AUTHENTICATION_TOKEN_EMAIL_STORAGE_KEY';

export const TEMP_EMAIL_KEY = 'TEMP_EMAIL';
export const SIGN_IN_PATH = '/accounts/sign-in';
export const ROOT_PATH = '/';

export const GOOGLE_SIGN_IN_PATH = '/users/auth/google_oauth2';
export const FORGOT_PASSWORD_PATH = '/authentication/forgot-password/new';

export const CLEAN_UP_USER_PATH =
  '/authentication/delegated-verification/cleanup';

export const EMAIL_FIELD_PLACEHOLDER = 'you@company.com';

export const INSUFFICIENT_FACTORS_ERROR = 'insufficient_factors';
export const TOO_MANY_UNVERIFIED_FACTORS_ERROR = 'too_many_unverified_factors';
export const USER_UNAUTHENTICATED_ERROR = 'user_unauthenticated';
export const UNAUTHORIZED_CREDENTIALS_ERROR = 'unauthorized_credentials';
export const TOO_MANY_REQUESTS_ERROR = 'too_many_requests';

export const TOO_MANY_REQUESTS_ERROR_MESSAGE = toI18n(
  'authentication.errors.too_many_requests'
);

export enum AuthError {
  FORMAT = 'format',
  RESET_PASSWORD = 'reset_password',
  INVALID_CREDENTIALS = 'invalid_credentials',
  PASSCODE_USED_OR_EXPIRED = 'passcode_used_or_expired',
  AD_BLOCKER_DETECTED = 'ad_blocker_detected',
  GENERAL = 'general',
}

export enum ResetPasswordError {
  BREACHED_PASSWORD = 'breached_password',
  SESSION_TOO_OLD_TO_RESET_PASSWORD = 'session_too_old_to_reset_password',
}

export enum SignInVariant {
  PHONE = 'phone send code',
  EMAIL = 'email sign in',
}

export enum PhoneFormStep {
  PHONE = 'phone send code',
  CODE = 'phone authenticate code',
}

export enum MfaVariant {
  SMS = 'mfa sms',
}

export enum ForgotPasswordStep {
  EMAIL = 'email code',
  CODE = 'authenticate code',
  PASSWORD = 'new password',
}
